import { isArray } from 'lodash';

export const getFirstStartCountId = (startCounts) => {
  if (startCounts && isArray(startCounts)) {
    return startCounts[0]?.id;
  }
  return new Error('startCounts not found');
};

export const getOptions = (startCounts) => {
  if (startCounts) {
    return startCounts.map((count) => ({
      label: count.name,
      value: count.id,
    }));
  }
  return [];
};

export const getSelectedValue = (options, startCountSelected) => {
  if (isArray(options)) {
    const findOption = options.find((option) => option.id === startCountSelected);
    if (findOption) {
      return {
        label: findOption.name,
        value: findOption.id,
      };
    }
    return null;
  }
  return new Error(`option not valid, ${typeof options}`);
};
